import Organization from '@/types/organizationType';
import { useUserLogged } from '@/hooks/useUserLogged';

/**
 * Gets the display name for the git provider based on organization or user context
 * @param organization - The organization object (optional)
 * @param userProvider - The user's provider string (optional)
 * @returns The display name for the provider (e.g., "GitHub", "GitLab", "Git Provider")
 */
export function getProviderDisplayName(
  organization?: Organization | null,
  userProvider?: string | null
): string {
  const providerSource = organization?.Source ?? userProvider ?? 'github';
  const provider =
    typeof providerSource === 'string'
      ? providerSource.toLowerCase()
      : 'github';

  if (provider === 'gitlab') {
    return 'GitLab';
  }

  if (provider === 'bitbucket') {
    return 'Bitbucket';
  }

  if (provider === 'github') {
    return 'GitHub';
  }

  // For self-hosted or unknown providers, use the raw provider string
  return provider || 'GitHub';
}

/**
 * Hook version that uses the current user/organization context
 * @returns The display name for the current provider
 */
export function useProviderDisplayName(): string {
  const { organization, user } = useUserLogged();
  return getProviderDisplayName(organization, user?.provider);
}
